import { render, staticRenderFns } from "./heatmap.vue?vue&type=template&id=ec5ba508&scoped=true&"
import script from "./heatmap.vue?vue&type=script&lang=js&"
export * from "./heatmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5ba508",
  null
  
)

export default component.exports